import type { CSSProperties } from 'react';

/** Typed inline CSS custom properties (dynamic values only), e.g. cssVars({ '--width': '40%' }). */
export const cssVars = (vars: Record<string, string>) => vars as CSSProperties;
